<template>
    <section>
        <UiUsefulLinks v-editable="blok" :blok="blok" class="apr-section" />
    </section>
</template>

<script setup lang="ts">
import type { IUsefulLinksConfig } from '@nuxt-monorepo/ui/types';

defineProps<{ blok: IUsefulLinksConfig }>();
</script>
<style lang="postcss" scoped>
:deep(.useful-links) {
    &.with-bg {
        @apply my-8 md:my-16;
    }
    .useful-links__subtitle {
        @apply hidden md:block text-left text-text-primary-asphalt text-base mb-8;
    }
    .container {
        @apply xl:p-0;
    }
    .title {
        @apply apr-section-title;
        + .links-row {
            @apply mt-6 sm:mt-8;
        }
    }
    .links-row {
        @apply flex flex-col md:flex-row flex-wrap md:-mx-4 gap-y-4 mt-6 md:mt-0;
    }
}
:deep(.link-text-component) {
    @apply text-base basis-1/2 lg:basis-1/4 md:px-4;
    .link {
        @apply font-semibold text-link mb-1;
        &:after {
            content: ' ';
            @apply relative top-[2px] left-2 h-4 w-3 inline-block bg-link;
            mask-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentcolor" d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>');
        }
    }
}
</style>
